import { render, staticRenderFns } from "./SliderBackArrow.vue?vue&type=template&id=4f55276c&"
import script from "./SliderBackArrow.vue?vue&type=script&lang=js&"
export * from "./SliderBackArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports